import axiosInstance from "./AxiosInstance";

export function getCategoriesList(data) {
  return axiosInstance.post(`/categories/list`, data);
}

export function deleteCategories(data) {
  return axiosInstance.post(`/categories/delete`, data);
}

export function createCategories(data) {
  return axiosInstance.post(`/categories/create`, data);
}

export function updateCategories(data) {
  return axiosInstance.post(`/categories/update`, data);
}

export function getSubCategoriesList(data) {
  return axiosInstance.post(`/sub-categories/list`, data);
}

export function deleteSubCategoriess(data) {
  return axiosInstance.post(`/sub-categories/delete`, data);
}

export function createSubCategories(data) {
  return axiosInstance.post(`/sub-categories/create`, data);
}

export function updateSubCategories(data) {
  return axiosInstance.post(`/sub-categories/update`, data);
}

export function getSearchCategories(data) {
  return axiosInstance.post(`/categories/search-list`, data);
}

export function getSearchSubCategories(data) {
  return axiosInstance.post(`/sub-categories/serach`, data);
}

export function ImportCategoriesList(data) {
  return axiosInstance.post(`/categories/import`, data);
}

export function ExportCategoriesList(data) {
  return axiosInstance.post(`/categories/export`, data);
}

export function ImportSubCategoriesList(data) {
  return axiosInstance.post(`/sub-categories/import`, data);
}

export function ExportSubCategoriesList(data) {
  return axiosInstance.post(`/sub-categories/export`, data);
}
